import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

interface LabelProps {
    label: string,
    secondary?: boolean,
}

class LabelBetween extends React.Component<LabelProps & WithStyles<typeof styles>, any> {

    render() {
        const classes = this.props.classes;

        return (
            <label
                className={`${classes.label} ${classes.secondary} ${classes.labelBetween}`}
                style={{ height: "100%" }}
            >
                {this.props.label}
            </label>
        );
    }
}

const styles = (theme: Theme) => ({
    label: {
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        fontSize: "12px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight,
        padding: "7px 0 4px"
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    labelBetween: {
        marginLeft: "12px",
        marginRight: "12px",
        display: "inline-block"
    },
});

export default withStyles(styles)(LabelBetween);